import z from "zod";

export const CmsImageFormatSchema = z.object({
  ext: z.string(),
  url: z.string(),
  hash: z.string(),
  mime: z.string(),
  name: z.string(),
  path: z.string().optional().nullable(),
  size: z.number(),
  width: z.number(),
  height: z.number(),
  sizeInBytes: z.number(),
});

export const CmsImageSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    alternativeText: z.string().optional().nullable(),
    caption: z.string().optional().nullable(),
    width: z.number(),
    height: z.number(),
    formats: z
      .object({
        large: CmsImageFormatSchema.optional().nullable(),
        small: CmsImageFormatSchema.optional().nullable(),
        medium: CmsImageFormatSchema.optional().nullable(),
        thumbnail: CmsImageFormatSchema.optional().nullable(),
      })
      .optional()
      .nullable(),
    hash: z.string(),
    ext: z.string(),
    mime: z.string(),
    size: z.number(),
    url: z.string(),
    previewUrl: z.string().optional().nullable(),
    provider: z.string(),
    provider_metadata: z.string().optional().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  }),
});
export type CMSImage = z.infer<typeof CmsImageSchema>;
